module.exports = __webpack_public_path__ + "files/d8097ff2299d020cf6c0781c946c59f1.png";